// extracted by mini-css-extract-plugin
module.exports = {"container":"Program_container__rx3WN","wrapper":"Program_wrapper__R814E","infolog1--text":"Program_infolog1--text__2RYJA","section":"Program_section__2EYjl"};